import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';

import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';

import { getSimpleVenuesTemplates } from '@go-client/lib/api/venueTemplate';
import { getPlan } from '@go-client/lib/api/plan';
import { getPropertyEventTemplates } from '@go-client/lib/api/eventTemplate';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const EventLog: React.FC<UserActionLog> = ({ body, url }) => {
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        let fields = {};
        const [_empty, _project, planId, _type] = url!.split('/');
        const plan = await getPlan(planId);

        const dayFields = FieldsReplacer(plan.day, logFields, [
          {
            from: 'name',
            to: 'day',
          },
        ]);
        fields = { ...fields, dayFields };

        // get venue information
        if (body.venue) {
          const venues = await getSimpleVenuesTemplates();
          const venue = venues.find(v => v._id === body.venue);
          if (venue) {
            const propertyFields = FieldsReplacer(venue, logFields, [
              {
                from: 'name',
                to: 'venue',
              },
            ]);

            fields = { ...fields, ...propertyFields };
          }
        }

        // get template information
        if (plan.property && body.template) {
          const templates = await getPropertyEventTemplates(plan.property);
          const template = templates.find(t => t._id === body.template)!;
          const templateFields = FieldsReplacer(template, logFields, [
            {
              from: 'title',
              to: 'template',
            },
          ]);

          fields = { ...fields, ...templateFields };
        }

        setLogFields({ ...logFields, ...fields });
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  if (isLoading) {
    return (
      <tr>
        <td colSpan={2} aria-colspan={2} className="text-center">
          <p className="text-grey-darker">Loading data...</p>
        </td>
      </tr>
    );
  }

  if (isError) {
    return (
      <tr>
        <td colSpan={2} aria-colspan={2} className="text-center">
          <p className="text-grey-darker">There was an error trying to load the data.</p>
        </td>
      </tr>
    );
  }

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
